import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export default function SignupOfferEditor() {
  const [o, setO] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/public/signup-offer").then((r) => setO(r.data)); }, []);
  if (!o) return null;
  const save = async () => {
    setBusy(true);
    try { setO((await api.put("/admin/signup-offer", { trial_days: Number(o.trial_days), credits: Number(o.credits) })).data); toast.success("Sign-up offer saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="lx-card space-y-3 lg:col-span-3" data-testid="admin-signup-offer">
      <div><div className="font-semibold">Sign-up offer</div><p className="text-xs text-slate-500">Free trial length and free AI credits given to every new workspace. Shown on the sign-up page. Existing accounts are not changed.</p></div>
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <label className="flex items-center gap-2">Free trial (days)<Input className="w-24 h-8" type="number" value={o.trial_days} onChange={(e) => setO({ ...o, trial_days: e.target.value })} data-testid="admin-signup-trial-days" /></label>
        <label className="flex items-center gap-2">Free AI credits<Input className="w-28 h-8" type="number" value={o.credits} onChange={(e) => setO({ ...o, credits: e.target.value })} data-testid="admin-signup-credits" /></label>
        <Button size="sm" onClick={save} disabled={busy} data-testid="admin-signup-offer-save">{busy ? "Saving..." : "Save sign-up offer"}</Button>
      </div>
    </div>
  );
}
